export * from './map';
export { default as AUFlag } from './svg/AUFlag';
export { default as Account } from './svg/Account';
export { default as AccountLogin } from './svg/AccountLogin';
export { default as AddAccount } from './svg/AddAccount';
export { default as AddShoppingBag } from './svg/AddShoppingBag';
export { default as AddWhite } from './svg/AddWhite';
export { default as Apple } from './svg/Apple';
export { default as ArrowNext } from './svg/ArrowNext';
export { default as ArrowUp } from './svg/ArrowUp';
export { default as Back } from './svg/Back';
export { default as Block } from './svg/Block';
export { default as BlueTips } from './svg/BlueTips';
export { default as CAFlag } from './svg/CAFlag';
export { default as CalendarEdit } from './svg/CalendarEdit';
export { default as CalendarMonth } from './svg/CalendarMonth';
export { default as CancelFilled } from './svg/CancelFilled';
export { default as CarouselActiveDot } from './svg/CarouselActiveDot';
export { default as CarouselDeActiveDot } from './svg/CarouselDeActiveDot';
export { default as Castlery } from './svg/Castlery';
export { default as Chair } from './svg/Chair';
export { default as Chat } from './svg/Chat';
export { default as CheckCircle } from './svg/CheckCircle';
export { default as ChevronDoubleLeft } from './svg/ChevronDoubleLeft';
export { default as ChevronDoubleRight } from './svg/ChevronDoubleRight';
export { default as ChevronDown } from './svg/ChevronDown';
export { default as ChevronLeft } from './svg/ChevronLeft';
export { default as ChevronRight } from './svg/ChevronRight';
export { default as ChevronUp } from './svg/ChevronUp';
export { default as Close } from './svg/Close';
export { default as CloseLeft } from './svg/CloseLeft';
export { default as ClosePopup } from './svg/ClosePopup';
export { default as CloseRight } from './svg/CloseRight';
export { default as Connect } from './svg/Connect';
export { default as DeviceError } from './svg/DeviceError';
export { default as Dimension } from './svg/Dimension';
export { default as DoNotDisturbOn } from './svg/DoNotDisturbOn';
export { default as EmojiObjects } from './svg/EmojiObjects';
export { default as ErrorTips } from './svg/ErrorTips';
export { default as Facebook } from './svg/Facebook';
export { default as Favorite } from './svg/Favorite';
export { default as FavoriteFilled } from './svg/FavoriteFilled';
export { default as FreeSwatchesAddToCart } from './svg/FreeSwatchesAddToCart';
export { default as Google } from './svg/Google';
export { default as Home } from './svg/Home';
export { default as HomeWork } from './svg/HomeWork';
export { default as Info } from './svg/Info';
export { default as Instagram } from './svg/Instagram';
export { default as Leaf } from './svg/Leaf';
export { default as LeftArrow } from './svg/LeftArrow';
export { default as LineLeftArrow } from './svg/LineLeftArrow';
export { default as LineRightArrow } from './svg/LineRightArrow';
export { default as LocalParking } from './svg/LocalParking';
export { default as Loyalty } from './svg/Loyalty';
export { default as MonetizationOn } from './svg/MonetizationOn';
export { default as OOS } from './svg/OOS';
export { default as Package } from './svg/Package';
export { default as PinchZoomTooltip } from './svg/PinchZoomTooltip';
export { default as Pinterest } from './svg/Pinterest';
export { default as Play } from './svg/Play';
export { default as PlayArrowFilled } from './svg/PlayArrowFilled';
export { default as PlayCircle } from './svg/PlayCircle';
export { default as PlayOutline } from './svg/PlayOutline';
export { default as PlayWhite } from './svg/PlayWhite';
export { default as ProductDimension } from './svg/ProductDimension';
export { default as ProductDimensionActivated } from './svg/ProductDimensionActivated';
export { default as QrCodeScanner } from './svg/QrCodeScanner';
export { default as Quote } from './svg/Quote';
export { default as Receipt } from './svg/Receipt';
export { default as Replay } from './svg/Replay';
export { default as Reviews } from './svg/Reviews';
export { default as RightArrow } from './svg/RightArrow';
export { default as SGFlag } from './svg/SGFlag';
export { default as ScheduleFilled } from './svg/ScheduleFilled';
export { default as Search } from './svg/Search';
export { default as ShadowDot } from './svg/ShadowDot';
export { default as Shipping } from './svg/Shipping';
export { default as ShoppingBag } from './svg/ShoppingBag';
export { default as ShoppingCart } from './svg/ShoppingCart';
export { default as StandardInfo } from './svg/StandardInfo';
export { default as Tiktok } from './svg/Tiktok';
export { default as UKFlag } from './svg/UKFlag';
export { default as USFlag } from './svg/USFlag';
export { default as UspCustomization } from './svg/UspCustomization';
export { default as UspPayNow } from './svg/UspPayNow';
export { default as VerifiedSecurity } from './svg/VerifiedSecurity';
export { default as Warning } from './svg/Warning';
export { default as WebClose } from './svg/WebClose';
export { default as WebLeft } from './svg/WebLeft';
export { default as WebRight } from './svg/WebRight';
export { default as Whatsapp } from './svg/Whatsapp';
export { default as ZoomIn } from './svg/ZoomIn';
export { default as InfoThin } from './svg/InfoThin';
export { default as FacebookOutline } from './svg/FacebookOutline';
export { default as PinterestOutline } from './svg/PinterestOutline';
export { default as TiktokOutline } from './svg/TiktokOutline';
export { default as InstagramOutline } from './svg/InstagramOutline';
export { default as MenuMore } from './svg/MenuMore';
export { default as Duplicate } from './svg/Duplicate';
export { default as OutlinedFacebook } from './svg/OutlinedFacebook';
export { default as OutlinedPinterest } from './svg/OutlinedPinterest';
export { default as OutlinedInstagram } from './svg/OutlinedInstagram';
export { default as OutlinedTiktok } from './svg/OutlinedTiktok';
export { default as Communication } from './svg/Communication';
